import React, { Component } from 'react';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';
import Validation from './Validation.js';

export default class CreateUser extends Component {
	constructor(props){
		super(props);
		this.state = {name:'',email:'',password:'',department:'Select',userType:'Select',localID:this.props.id};
		this.handleInput = this.handleInput.bind(this);
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	componentDidUpdate(prevProps){
		let s = this.state;
		if (this.props.submit !== prevProps.submit && this.props.submit){ //if the user has chosen to submit new user information
			if(s.name.trim() !== "" && s.email.trim() !== "" && s.password.trim() !== "" && s.department !== "Select" && s.userType !== "Select" && prevProps.submit === false){ //make sure user chose to submit information and that all information has been filled out
				this.props.onChange({complete:true,name:s.name.trim(),email:s.email.trim(),password:s.password.trim(),department:s.department,userType:s.userType,localID:this.props.id}); //pass state up to parent (BulkUser)
				this.setState({name:'',email:'',password:'',department:'Select',userType:'Select'}); //clear input fields
				this.props.failed(false);
			}else if(s.name.trim() !== "" || s.email.trim() !== "" || s.password.trim() !== "" || s.department !== "Select" || s.userType !== "Select"){ //if a field is empty, pass up new user information with the complete flag set to false to allow for error messages
				this.props.failed(false);
				this.props.onChange({complete:false,name:s.name.trim(),email:s.email.trim(),password:s.password.trim(),department:s.department,userType:s.userType,localID:this.props.id});
				this.setState({name:'',email:'',password:'',department:'Select',userType:'Select'});
			}
		}
	}

	render(){
		let inputStyles = "h2 pa2 br2 bw1 w-100 shadow-3";
		const departments = this.props.departments;
		const types = this.props.userTypes;
		const selectStyles = "h2 pa1 w-100 br2 bw1 truncate shadow-3";
		const tdStyle = "pa2"
		return(
			<tr>
				<td className={tdStyle}><Input identity="name" onInput={this.handleInput} inputStyle={inputStyles} val={this.state.name}/></td>
				<td className={tdStyle}><Input identity="email" onInput={this.handleInput} inputStyle={inputStyles} val={this.state.email}/></td>
				<td className={tdStyle}><Input identity="password" onInput={this.handleInput} inputStyle={inputStyles} val={this.state.password}/></td>
				<td className={tdStyle}><SelectBox identity="department" options={departments} onSelect={this.handleInput} styles={selectStyles} val={this.state.department}/></td>
				<td className={tdStyle}><SelectBox identity="userType" options={types} onSelect={this.handleInput} styles={selectStyles} val={this.state.userType}/></td>
			</tr>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CreateUser.js